import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useRef } from 'react';
import { createAppStore } from './store';
export const AppContext = createContext(null);
export const AppProvider = ({ children, ...props }) => {
    const storeRef = useRef();
    if (!storeRef.current) {
        storeRef.current = createAppStore(props);
    }
    return _jsx(AppContext.Provider, { value: storeRef.current, children: children });
};
